import React from 'react';
import { Zap, Shield, TrendingUp } from 'lucide-react';

const valueProps = [
  {
    icon: Zap,
    title: '15-Minute Results',
    description: 'Get comprehensive insights faster than a coffee break.',
    color: 'from-blue-400 to-blue-500',
    textGradient: 'from-blue-600 to-cyan-600'
  },
  {
    icon: Shield,
    title: 'Science-Based',
    description: 'Validated by decades of psychological research. AI-enhanced analysis.',
    color: 'from-purple-400 to-purple-500',
    textGradient: 'from-purple-600 to-pink-600'
  },
  {
    icon: TrendingUp,
    title: '89% Accuracy',
    description: 'Proven predictive validity. Results you can trust.',
    color: 'from-pink-400 to-pink-500',
    textGradient: 'from-orange-600 to-red-600'
  }
];

const HomeValueProps = () => {
  return (
    <section id="features" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {valueProps.map((prop, index) => (
            <div
              key={index}
              className="text-center animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="inline-flex items-center justify-center mb-6">
                <div className={`w-16 h-16 bg-gradient-to-br ${prop.color} rounded-2xl flex items-center justify-center shadow-sm`}>
                  <prop.icon className="w-8 h-8 text-white" strokeWidth={2} />
                </div>
              </div>

              <h3 className="text-2xl font-bold mb-3">
                <span className={`bg-gradient-to-r ${prop.textGradient} bg-clip-text text-transparent`}>
                  {prop.title}
                </span>
              </h3>

              <p className="text-gray-600 leading-relaxed">
                {prop.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeValueProps;
